import { PROGRESS_START, PROGRESS_FINISH, PROGRESS_FAIL } from "../../mutation-types";
import serialApi from "@/api/serial";
import transactionApi from "@/api/transaction";

const defaultState = () => ({
	dataProduk: [],
	dataSerial: [],
	dataWarehouse: [],
	listConvertSerial: [],
	pagination: {},
});

const state = defaultState();

const mutations = {
	reset(state) {
		Object.assign(state, defaultState());
	},
	setDataProduk(state, data) {
		state.dataProduk = data.map(el => {
			el.serial = []
			return el
		});
	},
	setDataWarehouse(state, data) {
		state.dataWarehouse = data
	},
	setListSerial(state, data) {
		state.dataSerial = [ ... state.dataSerial, ... data]
	},
	setListConvertSerial(state, data) {
		state.listConvertSerial = data.data
		state.pagination = data.pagination
	},
};

const actions = {
	getProduct({ commit }, param) {
		commit(PROGRESS_START, null, { root: true });
		serialApi.getProduct(param).then(({ data: { data } }) => {
			commit("setDataProduk", data.results);
			commit(PROGRESS_FINISH, null, { root: true });
		}).catch(() => {
			commit(PROGRESS_FAIL, null, { root: true });
		});
	},
	getWarehouse({ commit }, param) {
		commit(PROGRESS_START, null, { root: true });
		serialApi.getWarehouse(param).then(({ data: { data } }) => {
			commit("setDataWarehouse", data.results);
			commit(PROGRESS_FINISH, null, { root: true });
		}).catch(() => {
			commit(PROGRESS_FAIL, null, { root: true });
		});
	},
	getListSerial({ commit }, params) {
		return new Promise((resolve, reject) => {
			commit(PROGRESS_START, null, { root: true });
			serialApi.dataSerial(params).then(({ data: { data } }) => {
				commit("setListSerial", data.results);
				commit(PROGRESS_FINISH, null, { root: true });
				resolve()
			}).catch( err => {
				commit(PROGRESS_FAIL, null, { root: true })
				reject(err)
			});
		})
	},
	checkSerialMLM({ commit }, value) {
		return new Promise((resolve, reject) => {
			commit(PROGRESS_START, null, { root: true });
			transactionApi.checkSerialMLM(value).then(({ data: { data } }) => {
				commit(PROGRESS_FINISH, null, { root: true });
				resolve(data.results.serial_valid)
			}).catch( err => {
				commit(PROGRESS_FAIL, null, { root: true })
				reject(err)
			});
		})
	},
	requestConvert({ commit }, value) {
		return new Promise((resolve, reject) => {
			commit(PROGRESS_START, null, { root: true });
			serialApi.requestConvert(value).then(({ data }) => {
				commit(PROGRESS_FINISH, null, { root: true });
				resolve(data.message)
			}).catch( err => {
				commit(PROGRESS_FAIL, null, { root: true })
				reject(err.response)
			});
		})
	},
	getListConvertSerial({ commit }, param) {
		commit(PROGRESS_START, null, { root: true });
		serialApi.getListConvertSerial(param).then(({ data: { data } }) => {
			commit("setListConvertSerial", { data: data.results, pagination: data.pagination });
			commit(PROGRESS_FINISH, null, { root: true });
		}).catch(() => {
			commit(PROGRESS_FAIL, null, { root: true });
		});
	},
}

export default {
	namespaced: true,
	state,
	actions,
	mutations,
};